import { useCallback, useRef } from "react";

export const SUCCESSIVE_CLICK_TIMEOUT_MS = 500;

/**
 * Track the amount of successive clicks within a set interval between clicks.
 * E.g. when user makes 3 clicks in a row with short interval between them, the count will be 3.
 * This tries to repeat behavior of event.detail property, which is not reliable due to browser inconsistencies.
 */
export function useSuccessiveClickCount() {
    const clickCountRef = useRef(0);
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    const registerClick = useCallback(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => {
            clickCountRef.current = 0;
            timeoutRef.current = null;
        }, SUCCESSIVE_CLICK_TIMEOUT_MS);
        clickCountRef.current++;
        return clickCountRef.current;
    }, []);

    return {
        registerClick,
        clickCountRef,
    };
}
